<nav>
  <div class="navbar-wrapper">
    <div class="m-header">
      <a href="javascript:" class="b-brand">
        <img src="assets/images/longsc.png" alt="theme-logo" class="logodash logo logo-dark logo-lg" />
      </a>
    </div>
    <app-nav-content (NavCollapsedMob)="navCollapseMob()" class="scroll-div w-100 compact"></app-nav-content>
  </div>
</nav>
